import axios from 'axios';
import { useAsync } from 'react-use';

import { getAuthToken } from '@providers/AuthProvider';

import { IPaymentInfo } from '@folx-types/payment';
import { ApiEndpoints } from '@utils/endpoints';

const usePaymentMethod = () => {
	const state = useAsync(async () => {
		const authorizationToken = await getAuthToken();

		const response = await axios.get<IPaymentInfo>(`${ApiEndpoints.stripe}/payment-method`, {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				authorizationToken,
			},
		});

		return response.data;
	});

	return state;
};

export default usePaymentMethod;
